import { useBookDemo } from "./BookDemoModal";

export default function FinalCTA() {
  const { openBookDemo } = useBookDemo();
  return (
    <section id="book" className="py-16 md:py-24 bg-primary-600">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-semibold text-background-50 leading-tight mb-4">
            Don&apos;t find out about Article 50 from a fine.
          </h2>
          <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto mb-8 md:mb-10">
            Book a demo. We&apos;ll walk your team through the rubric, the private deployment, and the report format — in 30 minutes.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <button
              type="button"
              onClick={openBookDemo}
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-background-50 text-primary-700 font-semibold text-base rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a demo
            </button>
            <a
              href="#sample"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-background-300/50 text-background-50 font-medium text-base rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              See a sample report
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}